<div class="profile-container">
  <div class="sidebar">
    <div class="user-info">
      <div class="avatar">
        <img src="https://i.pravatar.cc/150?u=ilyas" alt="User Avatar">
      </div>
      <div class="username">İlyas Ağakişiyev</div>
    </div>
    <nav class="nav-menu">
      <a routerLink="my-profile" routerLinkActive="active" class="nav-item">
        <i class="icon-user"></i> Profilim
      </a>
      <a routerLink="my-requests" routerLinkActive="active" class="nav-item">
        <i class="icon-request"></i> Sorğularım
      </a>
      <a routerLink="my-ads" routerLinkActive="active" class="nav-item">
        <i class="icon-ads"></i> Elanlarım
      </a>
      <a routerLink="my-balance" routerLinkActive="active" class="nav-item">
        <i class="icon-balance"></i> Balansım
      </a>
      <a routerLink="payment-history" routerLinkActive="active" class="nav-item">
        <i class="icon-history"></i> Ödəniş tarixçəsi
      </a>
      <div class="nav-divider"></div>
      <a (click)="logout()" class="nav-item logout">
        <i class="icon-logout"></i> Çıxış
      </a>
    </nav>
  </div>
  <div class="content-area">
    <router-outlet></router-outlet>
  </div>
</div>
